<template>
    <form-field v-bind="fieldProps">
        <text-input v-bind="inputProps" @change="change($event)" @emitEvent="emitEvent($event, ['change'])"></text-input>

        <template #hint>
            <slot name="hint"></slot>
        </template>

        <template #right>
            <slot name="right"></slot>
        </template>

        <template #icon>
            <slot name="icon"></slot>
        </template>

        <template #error="{ error }">
            <slot name="error" :error="error"></slot>
        </template>
    </form-field>
</template>

<script>
    import FormFieldMixin from 'mixins/FormFieldMixin'
    import FormPrefillingMixin from 'mixins/FormPrefillingMixin'

    export default {
        mixins: [FormFieldMixin, FormPrefillingMixin],

        props: {
            placeholder: { type: String, default: undefined },
            type: { type: String, default: 'text' },
            isSuggested: { type: Boolean, default: false },
            maxDate: { type: String, default: undefined },
            minDate: { type: String, default: undefined },
            maxLength: { type: Number, default: undefined },
            minlength: { type: Number, default: undefined },
        },
    }
</script>
